<template>
  <iframe
    :src="twitchUrl"
    height="300"
    width="480"
    frameborder="0"
    scrolling="no"
    allowfullscreen="true"
    class="hidden bg-white md:block fixed bottom-1 left-1 border-2 border-purple-400 rounded-lg"
  />
</template>

<script>
export default {
  props: {
    twitchUrl: {
      type: String,
      required: true,
    },
  },
};
</script>
